import React from "react";
import Tooltip from "@mui/material/Tooltip";
import {Colors} from "../../../assets/colors/Colors";
import {modalCRUDService} from "../../../services/modalCRUDService";
import {FormProvider, useForm} from "react-hook-form";
import InputForm from "../../../components/ComponentesFormularios/InputForm";
import {classResponsiveForm, ERRORFIELDREQUIRED} from "../../../data/ConstantForm";
import {GlobalConstants} from "../../../data/GlobalConstants";
import {useDispatch} from "react-redux";
import {adminService} from "../../../services/apiAdmin";
import {getDateTime} from "../../../util/functions";



const FormPerfilesCRUD = ({ isEditing, isAddMode, properties }) => {

    const { data, params, tableRef } = properties;
    const dispatch = useDispatch();
    const methods = useForm({defaultValues: data});
    const { handleSubmit, control, formState: { errors } } = methods;


    const onSuccessSubmit = data => {
        if(isAddMode && isEditing){
            adminService.setCrearPerfil(data).then(
                response => {
                    const {status, msg} = response;

                    if (status) {

                        dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertSuccess , message: msg } });

                        tableRef.current.api.applyTransaction({
                          add: [{
                            id: data?.txPerfil,
                            intentos: data?.nbIntentosFallidos,
                            reuso: data?.nbReusoMaxPWD,
                            cambioDias: data?.nbCambioDiasPWD,
                            longitud: data?.nbLongitudMinPWD,
                            vigencia: data?.nbVigenciaMinPWD,
                            verificar: data?.fnVerificarPWD
                          }]
                        })

                        modalCRUDService.clear();

                    } else {
                        dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: msg } });
                    }

                },
                error => {
                        dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: error.toString() } });
                }
            );
        }
        else {
            adminService.setEditarPerfil(data).then(
                response => {
                    const {status, msg} = response;

                    if (status) {

                        dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertSuccess , message: msg } });

                        modalCRUDService.clear();

                        const rowNode = params.api.getRowNode(params.node.id);

                        rowNode.setDataValue("intentos", data?.nbIntentosFallidos);
                        rowNode.setDataValue("reuso", data?.nbReusoMaxPWD);
                        rowNode.setDataValue("cambioDias", data?.nbCambioDiasPWD);
                        rowNode.setDataValue("longitud", data?.nbLongitudMinPWD);
                        rowNode.setDataValue("vigencia", data?.nbVigenciaMinPWD);
                        rowNode.setDataValue("verificar", data?.fnVerificarPWD);

                    } else {

                        dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: msg } });

                    }

                },
                error => {

                    dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: error.toString() } });

                }
            );
        }
    }

    const onErrorSubmit = errors => {
        dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: 'Faltan campos obligatorios, por favor válida la información' } });
    }

    return (
        <FormProvider {...methods} >
            <div className="d-flex justify-content-end align-items-center">
                { isEditing &&
                <Tooltip title="Guardar" aria-label="guardar">
                    <a onClick={handleSubmit(onSuccessSubmit, onErrorSubmit)}
                       className="icon-container-actions d-flex">
                        <div style={{backgroundColor: Colors.COLOR_GREEN_DARK}}/>
                        <i style={{color: Colors.COLOR_GREEN_DARK}} className="fas fa-check fa-2x"/>
                    </a>
                </Tooltip>
                }
                <Tooltip title="Cancelar" aria-label="cancelar">
                    <a onClick={() => {modalCRUDService.clear()}} className="icon-container-actions d-flex">
                        <div style={{backgroundColor: Colors.RED_SWITCH_INACTIVE}}/>
                        <i style={{color: Colors.RED_SWITCH_INACTIVE}} className="fas fa-times fa-2x"/>
                    </a>
                </Tooltip>
            </div>
            <div className="container mx-0 px-0 w-100 mw-100 my-3">
                <div className="mx-2 text-center text-muted content-divider divider-form">
                    <span className="px-2" style={{color: Colors.COLOR_SKY_THEME}}>Información Perfil</span>
                </div>
                <div className="row mx-0 px-0 my-4">

                    <InputForm inputProps={{control}} readOnly={!isAddMode} disabled={!isEditing} identificador="txPerfil" label="Perfil"
                               placeholder="Ej: Perfil" type="text" required={true} className={`${classResponsiveForm}`}
                               customError={errors.txPerfil ? ERRORFIELDREQUIRED : null}/>

                    <InputForm inputProps={{control}} disabled={!isEditing} identificador="nbIntentosFallidos" label="Numero Intentos"
                               placeholder="Ej: 1" type="number" required={true} className={`${classResponsiveForm}`}
                               customError={errors.nbIntentosFallidos ? ERRORFIELDREQUIRED : null}/>

                    <InputForm inputProps={{control}} disabled={!isEditing} identificador="nbReusoMaxPWD" label="Reuso"
                               placeholder="Ej: 5" type="number" required={true} className={`${classResponsiveForm}`}
                               customError={errors.nbReusoMaxPWD ? ERRORFIELDREQUIRED : null}/>

                    <InputForm inputProps={{control}} disabled={!isEditing} identificador="nbCambioDiasPWD" label="Días cambio contrasena"
                               placeholder="Ej: 30" type="number" required={true} className={`${classResponsiveForm}`}
                               customError={errors.nbCambioDiasPWD ? ERRORFIELDREQUIRED : null}/>

                    <InputForm inputProps={{control}} disabled={!isEditing} identificador="nbLongitudMinPWD" label="Longitud min contrasena"
                               placeholder="Ej: 10" type="number" required={true} className={`${classResponsiveForm}`}
                               customError={errors.nbLongitudMinPWD ? ERRORFIELDREQUIRED : null}/>

                    <InputForm inputProps={{control}} disabled={!isEditing} identificador="nbVigenciaMinPWD" label="Vigencia en días"
                               placeholder="Ej: 10" type="number" required={true} className={`${classResponsiveForm}`}
                               customError={errors.nbVigenciaMinPWD ? ERRORFIELDREQUIRED : null}/>

                    <InputForm inputProps={{control}} disabled={!isEditing} identificador="fnVerificarPWD" label="Verificar"
                               placeholder="Ej: 1" type="number" required={true} className={`${classResponsiveForm}`}
                               customError={errors.fnVerificarPWD ? ERRORFIELDREQUIRED : null}/>

                </div>
            </div>
        </FormProvider>
    )

}

export default FormPerfilesCRUD;
